/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Execute_Detail7Inputs */

const en_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build against real clients, not the inspector alone.`)
};

const ar_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البناء على عملاء حقيقيين، لا على المفتش وحده.`)
};

const bn_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আসল ক্লায়েন্টের বিপরীতে তৈরি করুন, শুধু ইনস্পেক্টরে নয়।`)
};

const de_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwicklung auf Basis echter Clients, nicht nur gegen den Inspector.`)
};

const es_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollo con clientes reales, no solo con el inspector.`)
};

const fr_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partez de vrais clients, pas seulement de l'inspecteur.`)
};

const pt_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolva a partir de clientes reais, não só com o inspetor.`)
};

const zh_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对着真实客户端开发，不只对着调试器。`)
};

const tr_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca denetçiye değil, gerçek istemcilere karşı geliştirin.`)
};

const ru_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Работайте на реальных клиентах, а не только в инспекторе.`)
};

const pl_svc_mcp_server_development_execute_detail7 = /** @type {(inputs: Svc_Mcp_Server_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawdziwi klienci, nie sam inspektor.`)
};

/**
* | output |
* | --- |
* | "Build against real clients, not the inspector alone." |
*
* @param {Svc_Mcp_Server_Development_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_execute_detail7 = /** @type {((inputs?: Svc_Mcp_Server_Development_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_execute_detail7(inputs)
	if (locale === "de") return de_svc_mcp_server_development_execute_detail7(inputs)
	if (locale === "es") return es_svc_mcp_server_development_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_execute_detail7(inputs)
	return en_svc_mcp_server_development_execute_detail7(inputs)
});
export { svc_mcp_server_development_execute_detail7 as "svc_mcp-server-development_EXECUTE_detail" }